import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Clipboard from 'clipboard';
import _pick from 'lodash/pick';
import { hideModal, showModal } from '../../../actions/ModalActions';
import importImages from '../../../util/webpack';

const modalImages = importImages(require.context('../../../assets/images/doodles/', false, /\.(jpg|jpeg|png|gif|svg)(\?.*)?$/));

class ShareModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: new Clipboard('#share-modal-password-copy'),
      url: new Clipboard('#share-modal-url-copy')
    };

    this.state = {
      clipboard: undefined,
      isClipboardSupported: Clipboard.isSupported(),
      clipboardErrorMessage: undefined
    };
  }

  componentDidMount() {
    this.initializeClipboard();
  }

  componentWillUnmount() {
    this.destroyClipboard();
  }

  initializeClipboard() {
    const clipboard = new Clipboard('#share-modal-password-copy, #share-modal-url-copy');

    clipboard.on('success', (e) => {
      const target = e.trigger;
      const currentButtonText = target.innerText;
      target.innerText = 'Copied!';
      target.disabled = true;
      setTimeout(() => {
        target.innerText = currentButtonText;
        target.disabled = false;
      }, 1000);
    });

    clipboard.on('error', () => {
      let clipboardErrorMessage = '';
      if (/iPhone|iPad/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Select and copy.';
      } else if (/Mac/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Press ⌘-C to copy.';
      } else {
        clipboardErrorMessage = 'Press Ctrl-C to copy.';
      }
      this.setState({ clipboardErrorMessage });
      setTimeout(() => this.setState({ clipboardErrorMessage: undefined }), 5000);
    });

    this.setState({ clipboard });
  }

  destroyClipboard() {
    const { clipboard } = this.state;
    if (clipboard) clipboard.destroy();
    this.setState({
      clipboard: undefined
    });
  }

  render() {
    const { wedding, shareInfo, closeModal, openWebsiteSettingsModal, openCustomDomainModal } = this.props;
    const { isClipboardSupported } = this.state;

    // feature for typography style guide updates
    const production = window.zola.env === 'production';

    return (
      <div id="share-modal" className={production ? 'publish-share-modal text-center' : 'publish-share-modal-v2 text-center'}>
        <div className="modal-header">
          <img src={modalImages('birds1X')} alt="birds doodle" />
          <h2>Share Your Website</h2>
        </div>
        <div className="modal-body">
          <p className="body-text">Include your unique website address on save the dates, invitations, and more.</p>
          {shareInfo.enable_passcode && (
            <p className="body-text">Don&#39;t forget to include your password: <span className="semibold">{shareInfo.passcode}</span></p>
          )}
          <div className="share-link">
            <h4>{`${window.location.host}`}/wedding/<strong>{wedding.slug}</strong></h4>
          </div>
          <div className="actions">
            <button id="share-modal-url-copy" className={isClipboardSupported ? 'v2-button primary-button btn-wide btn-left' : 'hidden'} data-clipboard-text={`${window.location.protocol}//${window.location.host}/wedding/${wedding.slug}`}>
              Copy Link
            </button>
            <button className="v2-button secondary-button btn-wide btn-right" onClick={closeModal}>
              Done
            </button>
          </div>
          <p className="footer-text">Want to control if your website is visible on search engines<br />{shareInfo.enable_passcode ? 'or edit your password?' : 'or add a password?'} <Link to="/wedding/manage/website/manage" className="text-button" onClick={openWebsiteSettingsModal}>Manage your settings &rsaquo;</Link></p>
          { (window.zola.env === 'development' || window.zola.env === 'staging') ? (
            <p className="footer-text">Want to change your website address? <a target="_blank" rel="noopener noreferrer" className="text-button" onClick={openCustomDomainModal}>Find out how &rsaquo;</a></p>
          ) : (
            <p className="footer-text">Want to change your website address? <a href="https://help.zola.com/hc/articles/115001765672-How-can-I-change-my-wedding-website-address-" target="_blank" rel="noopener noreferrer" className="text-button">Find out how &rsaquo;</a></p>
          )}
        </div>
      </div>
    );
  }
}

ShareModal.propTypes = {
  wedding: PropTypes.shape({}),
  shareInfo: PropTypes.shape({}),
  closeModal: PropTypes.func,
  openWebsiteSettingsModal: PropTypes.func.isRequired,
  openCustomDomainModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  wedding: state.wedding.wedding,
  shareInfo: Object.assign({}, _pick(state.wedding.account, 'enable_passcode', 'passcode'))
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(hideModal()),
  openWebsiteSettingsModal: () => dispatch(showModal('WEBSITE_SETTINGS', {}, { size: 'md' })),
  openCustomDomainModal: () => dispatch(showModal('CUSTOM_DOMAIN_MODAL'))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareModal);



// WEBPACK FOOTER //
// ./src/components/common/ui/ShareModal.jsx